<template>

    <header id="header">
        <div class="container">
            <!--<div class="row">
                <div class="col-xs-12">
                    <div class="top-header">
                        <ul class="list-unstyled align-left">
                            <li>
                                <a href="#">Gå til Kemi-Oil <i class="fa fa-angle-right"></i></a>
                            </li>
                        </ul>
                        <ul class="list-unstyled socail-network">
                            <li><a href="#"><i class="social_facebook"></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>-->
            <div class="row header-holder">
                <div class="col-xs-12">
                    <div class="logo text-uppercase">
                        <router-link tag="a" :to="{name: 'Index'}">
                            <img src="/static/images/p_pedersen_logo.png" class="custom-logo" style="object-fit:contain;" />
                        </router-link>
                    </div>
                    <a @click="mobileMenuToggle" class="nav-opener"><i class="fa fa-bars"></i></a>
                    <nav id="nav" :class="{'mobile-show': this.showMobileMenu}">
                        <ul class="list-unstyled">

                            <li class="has-children" :class="{'active': $route.name.includes('Products')}">
                                <a href="javascript:void(0)">
                                    Transport
                                    <i class="fas fa-caret-down fa-fw"></i>
                                </a>
                                <ul class="children-list">
                                    <router-link tag="li" :to="{name: 'ProductsStykgods'}" :class="{'selected': $route.name === 'ProductsStykgods'}">
                                        Stykgods / Partigods
                                    </router-link>
                                    <router-link tag="li" :to="{name: 'ProductsHellast'}" :class="{'selected': $route.name === 'ProductsHellast'}">
                                        Hellast / Full load
                                    </router-link>
                                    <router-link tag="li" :to="{name: 'ProductsBulk'}" :class="{'selected': $route.name === 'ProductsBulk'}">
                                        Bulk
                                    </router-link>
                                    <router-link tag="li" :to="{name: 'ProductsKoel'}" :class="{'selected': $route.name === 'ProductsKoel'}">
                                        Køl / Frys
                                    </router-link>
                                    <router-link tag="li" :to="{name: 'ProductsFarligt'}" :class="{'selected': $route.name === 'ProductsFarligt'}">
                                        Farligt gods / ADR
                                    </router-link>
                                    <router-link tag="li" :to="{name: 'ProductsFragtfirma'}" :class="{'selected': $route.name === 'ProductsFragtfirma'}">
                                        Fragtfirma
                                    </router-link>
                                </ul>
                            </li>
                            
                            <li :class="{'active': $route.name === '???'}">
                                <a href="/#miljo">
                                    Miljø
                                </a>
                            </li>

                            <li :class="{'active': $route.name === 'Covid'}">
                                <router-link tag="a" :to="{name: 'Covid'}">
                                    COVID-19
                                </router-link>
                            </li>

                            <li :class="{'active': $route.name === 'About'}">
                                <router-link tag="a" :to="{name: 'About'}">
                                    Hvem er vi
                                </router-link>
                            </li>

                            <li :class="{'active': $route.name === 'Contact'}">
                                <router-link tag="a" :to="{name: 'Contact'}">
                                    Kontakt os
                                </router-link>
                            </li>

                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </header>

</template>
<style lang="scss" scoped>
#header {
    box-shadow: 0 5px 15px rgba(0, 0, 0, .5);

    .header-holder {
        padding: 0;
    }
}

#nav {

    &.mobile-show {
        transform: none !important;
        opacity: 1 !important;
        top: 136px !important;
        visibility: visible !important;
    }
}

#nav > ul {
    
    > li {
        padding: 5px 10px;
        border-radius: 4px;
        
        a {
            text-transform: none;
            font-weight: bold;
        }

        &.active{
            background: #8b0000 !important;
            
            a{
                color: #fff;
            }
        }
    }
}

@media (max-width: 768px) {
    #nav > ul > li.active {
        background: #ffffff !important;
        // color: #8b0000 !important;
        // font-weight: bold !important;

        a {
            color: #8b0000 !important;
        }
    }
}
</style>

<script>
    export default{
        data () {
            return {
                showMobileMenu: false,
                links: [
                    /* {
                        slug: 'Index',
                        name: 'Forside'
                    }, */
                    {
                        slug: 'FreightCompany',
                        name: 'Fragtfirma'
                    },
                    {
                        slug: 'Environment',
                        name: 'Miljø'
                    },
                    /* {
                        slug: 'Products',
                        name: 'Produkter'
                    }, */
                    {
                        slug: 'Covid',
                        name: 'COVID-19'
                    },
                    /* {
                        slug: 'Environment',
                        name: 'Miljø & sikkerhed'
                    }, */
                    {
                        slug: 'About',
                        name: 'Hvem er vi'
                    },
                    {
                        slug: 'Contact',
                        name: 'Kontakt os'
                    }
                ]
            }
        },
        methods: {
            mobileMenuToggle () {
                this.showMobileMenu = !this.showMobileMenu
            }
        },
        watch: {
            '$route.name': 'mobileMenuToggle'
        }
    }
</script>



// WEBPACK FOOTER //
// header.vue?3f72f816